import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { cloneData, mysqlDataTime } from 'src/app/helper/class/utilityHelper';
import { formTblFilter } from 'src/app/helper/interface/form-interface';
import { tableAction, tblFilterQuery, whereField } from 'src/app/helper/interface/response';
import { ButtonGroupComponent } from '../button/button.component';
import { FormGeneratorComponent } from '../form-generator/form-generator.component';
import { TableListComponent } from '../table-list/table-list.component';

@Component({
  selector: 'form-table-filter',
  templateUrl: './form-table-filter.component.html',
  styleUrls: ['./form-table-filter.component.scss']
})
export class FormTableFilterComponent {

  @Input({ required: true }) config: formTblFilter = {} as formTblFilter;
  @Output() btnClick: EventEmitter<{ key: string, data: any, whereField: whereField[] }> = new EventEmitter();
  @Input() filterBtnClick: ((keys: string, args?: any, whereField?: whereField, form_value?: any) => Promise<any>) | any;
  @Input() parentGetList: ((args?: any) => Promise<any>) | any;
  @Input() parenttblAction: ((id: string | number, args?: tableAction, data?: any,col?:string,form?:any) => Promise<any>) | any;
  @Input() viewAction: ((id: string | number, data?: any,col?:string) => Promise<any>) | any;
  @ViewChild('form') form: FormGeneratorComponent | undefined;
  @ViewChild('tableList') tableList: TableListComponent | undefined;
  @ViewChild('btnGroup') btnGroup!: ButtonGroupComponent
  filterLoader: boolean = false;
  showErr: boolean = false;

  constructor() { }

  onFilter(ev) {
    if (!this.form?.isValid()) {
      this.showErr = true
      return
    }
    this.showErr = false
    this.tableList?.reload()
  }
  reset() {
    this.form?.reset()
    this.tableList?.reload();
  }
  isValid() {
    return this.form?.isValid();
  }
  checkValid() {
    this.showErr = false;
    if (!this.isValid()) {
      this.showErr = true;
    }
    return this.isValid();
  }

  getFormValue() {
    return this.form?.getFormValue() || {}
  }
  getFormWhereArray(): whereField[] {
    const filter = this.getFormData(),
      whereField: whereField[] = this.tableList?.getWhereField() || [];
    Object.keys(filter).forEach(key => {
      if (filter[key]) {
        const va = filter[key] instanceof Date ? this.getDateValue(filter[key], key) : filter[key]
        const index: number | any = whereField?.findIndex(i => i.colName == key)
        if (index > -1) {
          whereField[index] = { colName: key, value: va }
        } else {
          whereField?.push({ colName: key, value: va })
        }
      }
    })
    return whereField
  }
  getDateValue(d: Date, key: string) {
    const col = this.config?.formConfig?.formData?.find(a => a.colName == key),
      type: any = col?.type
    return mysqlDataTime(d, type);
  }
  onClickBtn(ev: any, confirmData = {}) {
    const data = { ...this.getFormData(), ...confirmData || {} };
    if (this.checkValid()) {
      this.filterBtnClick?.(ev, data, this.getFormWhereArray(), this.getFormValue()).then((res: any) => {

      }).finally(() => this.btnGroup.loadingStatus(ev))
      // this.btnClick.emit({ key: ev, data: data, whereField: this.getFormWhereArray() });
    } else {
      //stop
      this.btnGroup.loadingStatus(ev);
    }
  }
  loadingStatus(type, status) {
    this.btnGroup.loadingStatus(type, status);
  }
  getFormData() {
    const filter = this.getPayload()
    Object.keys(filter).forEach(e => {
      filter[e] = filter[e] instanceof Date ? this.getDateValue(filter[e], e) : filter[e]
    })
    return filter
  }
  getPayload() {
    return this.form?.apiPayload() || {};
  }
viewActionCall = async (id: string | number, data: any,col?:string): Promise<any> => {
    return await this.viewAction(id, data,col, this.form?.getFormValue());
  }
  tblActionCall = async (id: string | number,type:any, data: any,col?:string): Promise<any> => {
    return await this.parenttblAction(id, type,data,col,this.form?.getFormValue());
  }
  getListData = async (e: tblFilterQuery): Promise<any> => {
    e = cloneData(e)
    this.filterLoader = true
    e.whereField = this.getFormWhereArray();
    e.payload = this.getPayload();
    if (this.config?.validateFormOnFetch) {
      if (this.isValid() == false) {
        this.filterLoader = false
        return { result: !this.config.tableConfig.isLazy ? [] : { totalRecord: 0, data: [] }, statusCode: 200 }
      }
    }
    return this.parentGetList(e).finally(() => this.filterLoader = false)
  }
}
